// TransparencySection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, DollarSign, FileCheck } from 'lucide-react';

const TransparencySection = () => {
  const transparencyPoints = [
    {
      icon: DollarSign,
      title: 'We Do Not Handle Salaries',
      description: 'Ivipass collects no wages and charges you nothing on behalf of an employer'
    },
    {
      icon: FileCheck,
      title: 'Your Contract Is With the Employer',
      description: 'The employment agreement is signed between you and the company hiring you'
    },
    {
      icon: Shield,
      title: 'What Our Fee Buys',
      description: 'What we charge pays for the support work we do, and nothing else'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Being Clear About Payments
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            Nothing about our charges is hidden
          </p>
        </motion.div>

        {/* Transparency Points Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {transparencyPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-surface rounded-full mb-4">
                  <Icon size={28} className="text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-primary mb-2">
                  {point.title}
                </h3>
                <p className="text-gray-600 text-sm font-light">
                  {point.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Additional Info Box */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-surface p-8 rounded-lg max-w-4xl mx-auto"
        >
          <p className="text-gray-700 text-sm font-light leading-relaxed text-center">
            Where a payment relates to the job itself, it goes to the employer or to the relevant authority, never through us. What Ivipass charges is for professional support work alone.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TransparencySection;
